import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "article.rhytname.hello.title",
    },
    description: {
        id: "article.rhytname.hello.description",
    },
});

export default messages;
